import { useQuery } from '@tanstack/react-query';

import { api } from '../lib/api-client';

import type { ConversationDetail } from '../lib/types';

/**
 * useConversation(id) — detalhe completo da conversa.
 *
 * Inclui últimas 30 mensagens já no payload (`messages[]`). Para carregar
 * histórico mais antigo, usar `useMessages(id)` com cursor reverso.
 */
export function useConversation(id: string | undefined): {
  data: ConversationDetail | undefined;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => void;
} {
  const query = useQuery({
    queryKey: ['conversation', id],
    queryFn: () => {
      if (id === undefined) throw new Error('conversation id required');
      return api.getConversation(id);
    },
    enabled: id !== undefined,
    staleTime: 30 * 1000,
  });
  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: () => void query.refetch(),
  };
}
